export const QuoteProviderCache: { accounts: { [key: string]: string }; providers: string[] } = {
  accounts: {},
  providers: []
};
